export default {
    all: { method: 'GET', url: 'fornecedor' },
    active: { method: 'GET', url: 'fornecedor/active' },
    get: { method: 'GET', url: 'fornecedor/get/{/id}' },
    create: { method: 'POST', url: 'fornecedor' },
    update: { method: 'PUT', url: 'fornecedor' },
    inactive: { method: 'DELETE', url: 'fornecedor/{/id}' },
};